import { dbDeleteVideo } from '@/db/actions'

export const handleFileRemoveVideo = async (file: string) => {
  if (!file.endsWith('.ts')) return

  await dbDeleteVideo(file)
}
